import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Checkbox} from '@tickchak/react-share/app';
import * as css from './ManagePromotion.css';
import {approvePromotion} from '../../redux/event/eventActions';
import {logGoogleEvent} from '../../utils/analytics';

interface PromotionPopupContentProps {
    pmid: number;
    feature: 'realtime' | 'publish';
}

function PromotionPopupContent({pmid, feature}: PromotionPopupContentProps) {
    const {t} = useTranslation('promotionMessage');
    const termsApproved = useSelector((state: any) => state.event.promotionMessage?.termsApproved);
    const commission = useSelector((state: any) => state.event.promotionMessage?.commission);

    const handleTermsApproved = (value: number) => {
        approvePromotion(pmid, value).then();
        logGoogleEvent(`${feature}_${value === 1 ? 'promotion_terms_approve_click' : 'promotion_terms_unapprove_click'}`, pmid, `pmid-${pmid}`, {
            popup_name: 'promotionPopup',
            feature
        });
    };

    return (
        <>
            <css.title>{t('popupMessageTitle')}</css.title>
            <css.text>{t('popupMessageText', {commission})}</css.text>
            <css.checkboxRow data-cy="promotion-terms-row">
                <Checkbox
                    checked={termsApproved === 1}
                    onChange={(e) => handleTermsApproved(e.target.checked ? 1 : -1)}
                    data-cy="promotion-terms-checkbox"
                />
                {t('termsApproved')}
            </css.checkboxRow>
            <css.contact>{t('contactDetails')}</css.contact>
        </>
    );
}

export default PromotionPopupContent;
